<template>
  <div class="conten">
    <div class="header">
      <el-button type="primary" @click="AddDatas">添加商品</el-button>
    </div>
    <div class="contents">
      <div class="cont">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待复核商品" name="reviewer">
            <div v-if="values == '待复核商品'">
              <ReviewerShop />
            </div>
          </el-tab-pane>
          <el-tab-pane label="在售商品" name="first">
            <!-- <div class="title">
              <span>物品图片</span>
              <span>物品信息</span>
              <span>物品状态</span>
              <span>操作</span>
            </div> -->

            <div class="shop_list" v-for="item in NewData" :key="item._id">
              <div class="shop_wu">
                <img :src="item.imag" class="imgs" />
              </div>
              <div class="shop_wu">
                <span>创建时间:{{ item.createTime }}</span>
                <span>物品名称：{{ item.text }}</span>
                <span>物品描述：{{ item.textt }}</span>
                <span>物品规格：{{ item.specification }}</span>
                <span>断当票号：{{ item.ticketNum }}</span>
                <span>重量：{{ item.weight + "/g" }}</span>
                <span>价格：{{ item.prick + "元" }}</span>
              </div>
              <div class="shop_wu">
                <span>物品状态：</span>
                {{ item.ismarket == true ? "在售" : "下架" }}
              </div>
              <div class="shop_wu">
                <span>操作：</span>
                <span>
                  <el-button type="primary" class="btn_bj" @click="redact(item)"
                    >编辑商品</el-button
                  >
                  <el-button
                    type="warning"
                    @click="goods_xj(item.text, item._id, item.prick)"
                    :disabled="!item.ismarket"
                    >下架商品</el-button
                  >
                  <el-button
                    type="danger"
                    @click="deletes(item.text, item._id, item.prick)"
                    >删除商品</el-button
                  >
                </span>
              </div>
            </div>
          </el-tab-pane>

          <!-- 下架物品 -->
          <el-tab-pane label="下架物品" name="OffShelf">
            <div class="shop_list" v-for="item in OffShelfData" :key="item._id">
              <div class="shop_wu">
                <img :src="item.imag" class="imgs" />
              </div>
              <div class="shop_wu">
                <span>创建时间:{{ item.createTime }}</span>
                <span>物品名称：{{ item.text }}</span>
                <span>物品描述：{{ item.textt }}</span>
                <span>物品规格：{{ item.specification }}</span>
                <span>断当票号：{{ item.ticketNum }}</span>
                <span>重量：{{ item.weight + "/g" }}</span>
                <span>价格：{{ item.prick + "元" }}</span>
              </div>
              <div class="shop_wu">
                <!-- <el-switch
                  v-model="item.ismarket"
                  active-text="在售"
                  inactive-text="下架"
                  @change="operate(item._id, item.text)"
                >
                </el-switch> -->
                <span>物品状态：</span>
                {{ item.ismarket == true ? "在售" : "下架" }}
              </div>
              <div class="shop_wu">
                <span>操作：</span>
                <span>
                  <el-button type="primary" class="btn_bj" @click="redact(item)"
                    >编辑商品</el-button
                  >
                  <el-button
                    type="warning"
                    @click="goods_xj(item.text, item._id, item.prick)"
                    :disabled="!item.ismarket"
                    >下架商品</el-button
                  >
                  <el-button type="danger" @click="deletes(item.text, item._id)"
                    >删除商品</el-button
                  >
                </span>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="订单中心" name="order">
            <!-- 订单中心 -->

            <div class="order" v-if="values == '订单中心'">
              <Order />
            </div>
          </el-tab-pane>

          <el-tab-pane label="操作日志" name="log">
            <div v-if="values == '操作日志'">
              <Logs />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <div>
      <el-dialog
        title="编辑商品"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose"
        v-if="dialogVisible"
      >
        <!-- <span></span> -->
        <ItemDetail
          :ItemData="ItemDetailData"
          @change="costPlannedAmountChange($event)"
        />

        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">关 闭</el-button>
          <!-- <el-button type="primary" @click="SendData">提 交</el-button> -->
        </span>
      </el-dialog>
    </div>

    <!-- 添加弹窗 -->
    <div>
      <el-dialog
        title="添加商品"
        :visible.sync="dialog"
        width="60%"
        :before-close="AddDatasClose"
        v-if="dialog"
      >
        <!-- <span></span> -->
        <AddItemData />

        <span slot="footer" class="dialog-footer">
          <el-button @click="AddDatasClose">关 闭</el-button>
          <!-- <el-button type="primary" @click="SendData">提 交</el-button> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import ItemDetail from "@/components/shop/ItemDetail.vue";
import AddItemData from "@/components/shop/AddItemData.vue";
import Order from "@/components/shop/Orders.vue";
import ReviewerShop from "@/components/shop/ReviewerShop.vue";
import Logs from "@/components/shop/Logs.vue";
export default {
  name: "Shops",
  data() {
    return {
      activeName: "first",
      ACCESS_TOKEN: "",
      NewData: [], //在售的商品
      value1: true, //销售状态
      dialogVisible: false,
      ItemDetailData: {}, //被点击的数据
      dialog: false, //添加商品的弹窗

      values: "商品列表", //当前页面
      OffShelfData: [], //下架的商品

      username: "", //当前登录的用户
    };
  },
  components: {
    ItemDetail,
    AddItemData,
    Order,
    ReviewerShop,
    Logs,
  },

  methods: {
    handleClick(e) {
      this.values = e.label;
      if (e.label == "下架物品") {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: 'db.collection("shop_hd").where({ismarket:false}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.OffShelfData = res.data.data;
          });
      }
    },
    //请求商城数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("shop_hd").where({ismarket:true,reviewer:true}).limit(1000).get()',
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.NewData = res.data.data;
        });
    },
    //回调函数
    operate(e, info) {
      console.log("我触发了", e, info);
    },

    //下架
    goods_xj(event, id, price) {
      console.log(price);
      this.$confirm(`是否将${event}下架`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("shop_hd").doc("${id}").update({data:{ismarket:false}})`,
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                //添加日志
                this.AddLogs(event, price, "下架");
                this.$message({
                  type: "success",
                  message: "下架成功!",
                });

                //刷新状态
                this.getData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //删除商品
    deletes(event, id, price) {
      this.$confirm(`是否将${event}删除`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("shop_hd").doc("${id}").remove()`,
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                //添加日志
                this.AddLogs(event, price, "删除");

                this.$message({
                  type: "success",
                  message: "删除成功!",
                });

                //刷新状态
                this.getData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //编辑商品
    redact(event) {
      this.dialogVisible = !this.dialogVisible;
      this.ItemDetailData = event;
    },

    async costPlannedAmountChange(value) {
      if (value == true) {
        this.handleClose();
      }
    },

    //关闭编辑商品弹窗
    handleClose() {
      this.dialogVisible = false;
      this.ItemDetailData = {};
    },

    //提交商品
    SendData() {},

    //添加商品
    AddDatas() {
      this.dialog = !this.dialog;
    },
    //添加商品关闭弹窗
    AddDatasClose() {
      console.log("关闭弹窗");
      this.dialog = false;
    },

    //添加日志
    //上传日志
    AddLogs(text, price, action) {
      this.axios.post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: `db.collection("logs").add({data:{price:"${price}",createDate:"${dayjs().format(
          "YYYY-MM-DD HH:mm:ss"
        )}",content:"${text}",action:"${action}商品",username:"${this.username}"}})`,
      });
    },
  },
  created() {
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.getData();
      this.username = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 100px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 50px;
}
.contents {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  margin: 20px auto;
}
.cont {
  width: 98%;
  margin: 0 auto;
}
.imgs {
  width: 200px;
  height: 200px;
}
.shop_list {
  /* width: 90%; */
  margin: 30px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* margin: 30px 0; */
  background-color: #f7f7f7;
}
.shop_wu {
  display: flex;
  flex-direction: column;
  margin: 20px 0;
}
.shop_wu span {
  margin: 10px 0;
  font-size: 12px;
}
.title {
  width: 99%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.btn_bj {
  margin: 10px 0;
}
</style>
